export enum RuleTypeEnum {
  Comparison = "Comparison",
  Validation = "Validation",
  Causality = "Causality",
  Historical = "Historical",
}

export enum ValidationRuleTypeEnum {
  Required = 0,
  MinValue = 1,
  MaxValue = 2,
  MinLength = 3,
  MaxLength = 4,
  DateAfter = 5,
  DateBefore = 6,
  RegexPattern = 7,
  Custom = 8,
  EqualTo = 9,
  NotEqualTo = 10,
}

export enum ComparisonTypeEnum {
  GreaterThan = 0,
  LessThan = 1,
  EqualTo = 2,
  NotEqualTo = 3,
  GreaterOrEqualTo = 4,
  LessOrEqualTo = 5,
}

export enum RuleStateEnum {
  Active = 0,
  Inactive = 1,
}

export enum ChangeStateEnum {
  OnRevision = 0,
  ToSend = 1,
  Sent = 2,
  OnQuery = 3,
  Discarded = 4,
}

export const PhaseDictionary: { [key: string]: string } = {
  "9": "0",
  "36": "4",
  "11": "1",
  "13": "2",
  "19": "3",
  "44": "5",
  "47": "6",
};


